import { render, staticRenderFns } from "./DiskOsChart.vue?vue&type=template&id=78942e14&scoped=true&"
import script from "./DiskOsChart.vue?vue&type=script&lang=js&"
export * from "./DiskOsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78942e14",
  null
  
)

export default component.exports